import { render } from "./OrderDetailPage.vue?vue&type=template&id=16bf2560&ts=true"
import script from "./OrderDetailPage.vue?vue&type=script&lang=ts"
export * from "./OrderDetailPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__